export function EditorEmptyPanel() {
    return (
        <></>
    );
}
